import { reactive } from 'vue';
import Axios from 'axios';
import { useFetch } from './useFetch';

export interface Customer {
    first_name: string;
    last_name: string;
    birthdate: string;
    id_card: string;
    phone: string;
    email: string;
    address_street: string;
    address_city: string;
    address_post_code: string;
    address_country: string;
}

export const useCustomer = () => {
    const { protectedFetch } = useFetch();

    const getDefaultCustomerData = (): Customer => ({
        first_name: '',
        last_name: '',
        birthdate: '', // Not necessary any longer
        id_card: '', // Not necessary any longer
        email: '',
        phone: '',
        address_street: '',
        address_city: '',
        address_post_code: '',
        address_country: 'SK',
    });

    const getInitialCustomerData = (customer: Customer | undefined) => {
        let userData = getDefaultCustomerData();

        if (customer) {
            userData = { ...userData, ...customer };
        }

        return userData;
    };

    const saveCustomerDataOnServer = (value: Customer) => {
        protectedFetch<Customer, unknown>({ method: 'post', url: '/reservation/customer', data: value });
    };

    return {
        saveCustomerDataOnServer,
        getDefaultCustomerData,
        getInitialCustomerData,
    };
};
